import React from 'react';
import { get } from 'lodash';

// for InfoText for BreachType
export const InfoTextWithList = (
  <div style={{ marginTop: 2 }}>
    Regulatory or legal obligations relating to:
    <br />
    1. Claims handling services
    <br />
    2. Disclosure documents
    <br />
    3. Sales practices
    <br />
    4. Financial service advice
    <br />
    5. Insurance contracts act requirements
    <br />
  </div>
);

export const PROVIDER_NAMES = {
  STEP1: 'What brings you here?',
  STEP2: 'Your details',
  STEP3: 'Customer details',
  STEP4: 'Tell us more',
  STEP5: 'Thank you',
};

export const FIN_PROVIDER_NAMES = {
  STEP1: 'What brings you here?',
  STEP2: 'Your details',
  STEP3: 'Insured details',
  STEP4: 'Tell us more',
  STEP5: 'Employment',
  STEP6: 'Income / Expenses',
  STEP7: 'Thank you',
};

export const ANALYTICS_NAMES = {
  STEP1: 'landing',
  STEP2: 'consent',
  STEP3: 'customer-details',
  STEP4: 'complaint-information',
  STEP5: 'success',
};

export const FIN_ANALYTICS_NAMES = {
  STEP1: 'landing',
  STEP2: 'consent',
  STEP3: 'insured-details',
  STEP4: 'tell-us-more',
  STEP5: 'employment',
  STEP6: 'income/expense',
  STEP7: 'success',
};

export const AUSTRALIAN_STATE = ['NSW', 'QLD', 'ACT', 'VIC', 'WA', 'NT', 'TAS', 'SA'];
export type AuStateType = (typeof AUSTRALIAN_STATE)[number];
export const AUSTRALIA = 'Australia';
export const MIN_ADDRESS_SEARCH_STRING = 4;

export interface TextValueType {
  text: string;
  value: string;
}

export const YesNoList: TextValueType[] = [
  {
    text: 'Yes',
    value: 'yes',
  },
  {
    text: 'No',
    value: 'no',
  },
];

export const ClaimPolicyList: TextValueType[] = [
  {
    text: 'Claim',
    value: 'claim',
  },
  {
    text: 'Policy',
    value: 'policy',
  },
];

export interface TextValueType {
  text: string;
  value: string;
}

export interface InfoTextValueType {
  text: string;
  value: string;
  infoPopUp: React.ReactNode;
}

export const breachTypes = [
  {
    text: 'Data, Privacy, Security',
    value: 'Data, Privacy, Security',
    infoPopUp: {
      content:
        'An incident which involves unauthorised access, use or disclosure of personal information, loss of personal information, and/or a compromise of information security',
    },
  },
  {
    text: 'Dealings Outside of TMD',
    value: 'Dealings Outside of TMD',
    infoPopUp: {
      content:
        'Selling a retail product to a customer where it is not suitable and who are, or should be, outside QBE’s Target Market Determination (TMD)',
    },
  },
  {
    text: 'Financial Services Law',
    value: 'Financial Services Law',
    infoPopUp: {
      content: InfoTextWithList,
    },
  },
  {
    text: 'GI Code of Practice',
    value: 'GI Code of Practice',
    infoPopUp: {
      content: 'Failing to comply with Code standards in conduct and customer service',
    },
  },
];

export const AllowedFileTypesDev = ['doc', 'docx', 'eml', 'jpeg', 'jpg', 'pdf', 'png', 'xls'];

export const AllowedFileTypes = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpeg', 'jpg', 'eml', 'zip', 'rar', '7z'];

export const AllowedFileTypesCombined = get(window, '_CMS_.ALLOWED_FILE_EXTENSIONS', []);

export const SEPARATOR = '__';

export const lodgementType = [
  {
    text: 'Complaint',
    value: 'complaint',
  },
  {
    text: 'Financial hardship application',
    value: 'fha',
  },
  {
    text: 'Incident/Breach',
    value: 'breach',
  },
] as const;

type LodgementValues = (typeof lodgementType)[number]['value'];

export const lodgementTypeValues: LodgementValues[] = lodgementType.map(({ value }) => value);
